import {Fragment, h} from "preact";
import {t} from '../../_i18n';

export const Requirements = () => <div className="max-width-sm margin-auto">
  <span innerHTML={t('student_requirement_1')}></span>
  <div className="innerText">
      <p>{t('student_requirement_2')}</p>
  </div>
  <div className="innerText">
      <p>{t('student_requirement_3')}</p>
  </div>
  <span innerHTML={t('student_requirement_4')}></span>
</div>;

